import { twMerge } from "tailwind-merge";

const Field = ({ label, value, inline, dtClasses, ddClasses }) => (
    <div className="mt-2">
        <dt className={twMerge("text-sm font-bold text-black-900", dtClasses, inline && 'inline')}>{label}</dt>
        <dd className={twMerge("ml-1 text-sm text-gray-900", ddClasses, inline && 'inline')}>{value}</dd>
    </div>
);

export default Field;